import { Component } from '@angular/core';
import { UserService } from './_services';
import { environment } from '@env/environment';
import { SharedService } from './shared/shared.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { HelperFunctions } from './shared/Helpers/helperFunctions';
import { IOrganisation } from './shared/interfaces';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  private hostname: string;
  private organisation: IOrganisation;
  private returnUrl: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private sharedService: SharedService
  ) {
    this.organisation = null as IOrganisation;
    this.sharedService.resetLoginCustomisation();
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'];
        this.getHostName();
      }
    });
  }

  private getHostName() {
    if (this.returnUrl != undefined) {
      if (this.returnUrl.toString().trim().length > 1) {
        const parser = document.createElement('a');
        parser.href = this.returnUrl
        if (HelperFunctions.isIE()) {
          this.hostname = parser.hostname;
        }
        else {
          this.hostname = parser.host;
        }
        this.getOrganisationByUrl();
      }
      else {
        this.sharedService.changeLoadedOrganisation(false);
      }
    }
    else {
      this.sharedService.changeLoadedOrganisation(false);
    }
  }

  private getOrganisationByUrl() {
    if (this.hostname !== environment.default_return_url) {
      this.sharedService.changeLoadedOrganisation(true);
      this.userService.getOrganisationByUniqueUrl(this.hostname).subscribe({
        next: (res) => {
          this.organisation = res.body;
          this.sharedService.changeOrganisationObject(this.organisation);

          if (this.organisation.organisationFeature != null) {
            if (this.organisation.organisationFeature.loginCustomisation != null) {
              this.sharedService.changeLoginCustomisaiton(this.organisation.organisationFeature.loginCustomisation);

              if (this.organisation.organisationFeature.loginCustomisation.backImagePath != null) {
                this.userService.getImage(this.organisation.organisationFeature.loginCustomisation.backImagePath).subscribe({
                  next: (responseBackground) => { this.sharedService.changeBackgroundImage(responseBackground.body); }
                })
              }

              if (this.organisation.organisationFeature.loginCustomisation.logoPath != null) {
                this.userService.getImage(this.organisation.organisationFeature.loginCustomisation.logoPath).subscribe({
                  next: (responselogo) => { this.sharedService.changeLogoImage(responselogo.body); }
                })
              }
            }
          }
        }
      })
    } else {
      this.sharedService.changeLoadedOrganisation(false);
    }
  }
}
